/* @flow */
/* React, browser and server rendering functions. We need the
 * first import as JSX compiled to React.createComponent(...) */
import 'babel-polyfill';
import React from 'react';
import {render as renderToDom} from 'react-dom';
import {ThemeProvider} from '@nike/ruxac';
import {cbdTheme} from './cbdTheme';
import '@nike/ruxac/fonts';
import '@nike/ruxac/styles';
import './style.less';

/* Hot-module reloading */
import {AppContainer} from 'react-hot-loader';

/* State management with redux */
import {Provider} from 'react-redux';

/* Routing with react-router */
import {BrowserRouter} from 'react-router-dom';

import App from './containers/App';

import createStore from './createStore';

const store = createStore (window.__INITIAL_STATE__);

const render = Component => {
  const app = (
    <ThemeProvider theme={cbdTheme}>
      <AppContainer>
        <Provider store={store}>
          <BrowserRouter>
            <Component />
          </BrowserRouter>
        </Provider>
      </AppContainer>
    </ThemeProvider>
  );

  renderToDom (app, document.getElementById ('root'));
};

render (App);

// Register with Hot Module Replacement API
if (module.hot) {
  module.hot.accept ('./containers/App', () => {
    render (App);
  });
}



// WEBPACK FOOTER //
// ./src/index.js